import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ClientConnection } from '../models';

@Injectable()
export abstract class ClientConnectionsService {
    abstract clientConnections(): Observable<ClientConnection[]>;

    abstract clientConnection(id: string): Promise<ClientConnection>;
}
